import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "environments/environment";
import { Subject } from "rxjs";

@Injectable({ providedIn: 'root' })
export class DocumentoMdService {
    constructor(private http: HttpClient) { }

    getDocumentacionMd(iditem:number) {
            let subject = new Subject<any>();
            this.http.get<any[]>(`${environment.com_documentacions}?filter[iditem]=${iditem}`)
                .subscribe((resp: any) => {
                    subject.next(resp.result)
                });
            return subject.asObservable();
        }
    
}